import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { CardContent } from "../../components/antd/card/CardContent";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpInputNumber } from "../gvc/testNewForm/CpInputNumber";
import { CpLabelTooltip } from "../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../gvc/testNewForm/CpTooltip";

interface Props {}
export const SessionTimeout: React.FC<Props> = ({}) => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Session Timeout</CardTitle>

          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`sessionTimeoutSeconds`}>Session Timeout</CpLabel>
                <CpTooltip
                  tooltipProps={{
                    title: `Set in seconds, console will log out users after inactivity for this much seconds. If there are multiple
                orgs open in different tabs, the lowest value will be taken into account.`,
                  }}
                />
              </CpLabelTooltip>
              <CpInputNumber name={`sessionTimeoutSeconds`} addonAfter={`Seconds`} style={{ minWidth: 450 }} />
              <CpErrorWarning name={`sessionTimeoutSeconds`} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
